import { render, staticRenderFns } from "./Pill.vue?vue&type=template&id=405e70d4&scoped=true"
import script from "./Pill.vue?vue&type=script&lang=js"
export * from "./Pill.vue?vue&type=script&lang=js"
import style0 from "./Pill.vue?vue&type=style&index=0&id=405e70d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e70d4",
  null
  
)

export default component.exports